/**
 * The `key` to use to interact with document metadata atoms when on routes that correspond to the
 * pattern `<document-id>`.
 */
export function metadataKeyForDocsRoute(documentId: string): string {
	return `document-metadata::${documentId}`;
}
